import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinProps',
})
export class JoinPropsPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  transform(value: any, displayPattern: { keys: string[]; separator: string }, defaultValue: string): string {
    return value && displayPattern?.keys?.length
      ? displayPattern.keys.map((item) => value[item]).join(displayPattern.separator)
      : defaultValue;
  }
}
